import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { Vehicle } from './vehicle/vehicle.component'
import ImageMotorcycle from './assets/sg/motorcycle.svg'
import ImageSedan from './assets/sg/sedan.svg'
import ImageVan from './assets/sg/van.svg'
import ImageLorry10ft from './assets/sg/lorry_10ft.svg'
import ImageLorry14ft from './assets/sg/lorry_14ft.svg'
import ImageLorry24ft from './assets/sg/lorry_24ft.svg'

const VehicleListSG = ({ estimations, quoteInProgress }) => {
  const [t] = useTranslation()

  const motorcycleFee = estimations.motorcycle || t('text__body__minimum_fee__motocycle')
  const sedanFee = estimations.sedan || t('text__body__minimum_fee__sedan')
  const vanFee = estimations.van || t('text__body__minimum_fee__van')
  const lorry10Fee = estimations.lorry10 || t('text__body__minimum_fee__lorry_10ft')
  const lorry14Fee = estimations.lorry14 || t('text__body__minimum_fee__lorry_14ft')
  const lorry24Fee = estimations.lorry24 || t('text__body__minimum_fee__lorry_24ft')

  const defaultFee = Object.keys(estimations).length === 0

  return (
    <>
      <Vehicle
        image={ImageMotorcycle}
        name={t('common__vehicle__motorcycle')}
        description={t('text__body__vehicle_description__motorcycle')}
        fee={motorcycleFee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageSedan}
        name={t('common__vehicle__sedan')}
        description={t('text__body__vehicle_description__sedan')}
        fee={sedanFee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageVan}
        name={t('common__vehicle__van')}
        description={t('text__body__vehicle_description__van')}
        fee={vanFee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageLorry10ft}
        name={t('common__vehicle__lorry_10ft')}
        description={t('text__body__vehicle_description__lorry_10ft')}
        fee={lorry10Fee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageLorry14ft}
        name={t('common__vehicle__lorry_14ft')}
        description={t('text__body__vehicle_description__lorry_14ft')}
        fee={lorry14Fee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
      <Vehicle
        image={ImageLorry24ft}
        name={t('common__vehicle__lorry_24ft')}
        description={t('text__body__vehicle_description__lorry_24ft')}
        fee={lorry24Fee}
        defaultFeeStyle={defaultFee}
        quoteInProgress={quoteInProgress}
      />
    </>
  )
}

VehicleListSG.propTypes = {
  estimations: PropTypes.object,
  quoteInProgress: PropTypes.bool,
}

export { VehicleListSG }
